import { useEffect, useState } from 'react';
import axiosInstance from '../../helpers/axios';

// Only fetch when Status is open, or we're already on a /status page.
export function useStatusCounts({ isOpen, pathname, productType }) {
  const [statusCounts, setStatusCounts] = useState([]);

  useEffect(() => {
    if (!isOpen && !pathname.includes('/status')) return;

    const params = {};
    if (productType && productType !== 'all') {
      params.productType = Number(productType);
    }

    axiosInstance
      .get('/admin/application/count', { params })
      .then((response) => setStatusCounts(response.data.data))
      .catch((error) => console.error(error));
  }, [pathname, isOpen, productType]);

  return statusCounts;
}
